export const LOADING_DEPARTAMENTO = "LOADING_DEPARTAMENTO";
export const LOADING_PROVINCIA = "LOADING_PROVINCIA";
export const LOADING_DISTRITO = "LOADING_DISTRITO";
export const DEPARTAMENTOS = "DEPARTAMENTOS";
export const PROVINCIAS = "PROVINCIAS";
export const DISTRITOS = "DISTRITOS";
export const DOMICILIO_ERROR_API = "DOMICILIO_ERROR_API";

export const SELECT_DOMICILIO = "SELECT_DOMICILIO";
export const CLEAN_DOMICILIO = "CLEAN_DOMICILIO";
export const CLEAN_UBIGEO = "CLEAN_UBIGEO";
